export enum SupportedCharts {
    LINE = 'Line',
    // Future chart types can be added here
}

export enum ChartSettingsTabs {
    GENERAL = 'general',
    DATA = 'data',
    LEGEND = 'legend',
    STYLE = 'style',
    EXPORT = 'export',
    DIMENSIONS = 'dimensions',
    SERIES = 'series',
    X_AXIS = 'xAxis',
    Y_AXIS = 'yAxis',
    TITLE = 'title',
    SOURCE = 'source',
    LOGO = 'logo',
    SPACING = 'spacing',
    THEME = 'theme',
    DEBUG = 'debug',
}
